<template>
  <div class='single-chart-circle'>
    <svg viewBox="0 0 36 36" class="circular-chart">
      <circle cx="18" cy="18" r="15.1" fill="transparent" :stroke='configOrDefault("backgroundStroke", "#eeeeee")' :stroke-width='1.3'/>
      <circle stroke-linecap="round" transform='rotate(-90)' transform-origin='50% 50%' cx="18" cy="18" r="15.1" fill="transparent" :stroke='strokeColour' :stroke-width='1.3' :stroke-dasharray="arcStroke()"/>
      <g transform="translate(0, -2)">
        <text v-if='configOrDefault("showPercent", true)' x="18" y="20.5" :font-size='titleFontSize' :fill='configOrDefault("textColor", "#ababab")' class="percentage" :style='{fill: configOrDefault("textColor", "#ababab")}'>{{content.title}}</text>
        <text x="18" y="25" v-if='configOrDefault("showText", true)' :fill='configOrDefault("textColor", "#ababab")' :font-size='textFontSize' textLength="18" lengthAdjust="spacingAndGlyphs" class='helptext'>{{content.text}}</text>
      </g>
    </svg>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import Utilities from '../../../lib/Utilities'
export default {
  props: {
    config: {
      type: Object,
      default () { return {} }
    },
    translationContext: {
      type: String,
      default: ''
    }
  },
  inject: ['theme'],
  computed: {
    ...mapState(['scoreCache', 'result']),
    strokeColour () {
      return this.content.stroke || this.theme.accent.backgroundColor
    },
    titleFontSize () {
      if (this.content.displayAs === 'percentage') {
        return '65%'
      } else {
        return '39%'
      }
    },
    textFontSize () {
      return '17%'
    }
  },
  data () {
    return {
      content: {},
      ready: false
    }
  },
  methods: {
    arcStroke () {
      const pc = this.percentVal()
      return (0.95 * pc) + ', 100'
    },
    percentVal () {
      return this.content.progress
    },
    replaceResultTokens (text) {
      let finalText = text
      const matches = [...text.matchAll(/\$(.+?)\$/g)]
      matches.forEach((match)=>{
        let resultValue = Utilities.getPropertyByPath(this.result, match[1], '')
        let matchString = match[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        finalText = finalText.replace(new RegExp(matchString, 'g'), resultValue)
      })
      return finalText
    },
    getResult () {
      if (this.content.dataSourceType === 'static'){
        return
      }
      // Request the named result from store/api then display according to displayStyle

      const progress = Utilities.getPropertyByPath(this.result, this.content.dataValue, false)
      if (!progress) {
        return
      }
      this.content.progress = (progress * 100).toFixed()
      this.content.text = this.replaceResultTokens(this.content.dataText)
      this.content.title = this.replaceResultTokens(this.content.dataTitle)
    },
    configOrDefault (key, defaultValue) {
      if (typeof this.content[key] !== 'undefined') {
        return this.content[key]
      } else {
        return defaultValue
      }
    }
  },
  mounted () {
    this.getResult()
  },
  created () {
    this.content = this.config
    //this.$watch('content', this.onChange, {deep: true})
  },
  watch: {
    progress (oldVal, newVal) {
      this.ready = true
    }
  }
}
</script>
<style lang='scss' scoped>
.single-chart-circle {
  width: 100%;
  justify-content: center ;
}

.circular-chart {
  width: 100%;
  display: block;
  margin: 10px auto;
}

.circle-bg {
  fill: none;
}

.circle {
  fill: none;
  stroke-linecap: round;
}

.ready {
  animation: progress 1s ease-out forwards;
}

.splash .column:last-child {padding-top:2%!important;display:none;}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.percentage {
  text-anchor: middle;
}

.helptext {
  text-anchor: middle;
}
</style>
